<template>
  <div>
    <section class="hero is-fullheight is-medium is-light is-bold">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-centered">
            <article class=" card is-rounded">
              <div class="card-content">
                <h1 class="title">
                  Logga in
                </h1>
                <div class="field">
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="email" placeholder="Email" v-model="email">
                    <span class="icon is-small is-left">
                      <i class="fas fa-envelope"></i>
                    </span>
                    <span class="icon is-small is-right">
                      <i class="fas fa-check" style="color:green" v-if="validateEmail()"></i>
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="password" placeholder="Password" v-model="password">
                    <span class="icon is-small is-left">
                      <i class="fas fa-lock"></i>
                    </span>
                    <span class="icon is-small is-right">
                      <i class="fas fa-check" style="color:green" v-if="password"></i>
                    </span>
                  </p>
                </div>
                <p class="control">
                  <button type="submit" class="button is-primary is-medium is-fullwidth" @click="login">
                    Login
                  </button>
                </p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'

  export default {
    name: 'Login',
    data: () => {
      return {
        email: "",
        password: "",
        validateEmail: function(){
          return this.email.includes("@") && this.email.includes(".")
        }
      }
    },
    methods: {
      login: function () {
        this.$store.dispatch("login", {
          email: this.email,
          password: this.password
        })
      },
      logout: function () {
        this.$store.dispatch("logout")
      }
      
    },
    computed: mapState(["authStatus"]),
    watch: {
      authStatus: (newVal) => {
        if (newVal == "error") {
          alert("Wrong credentials")
        }
      }
    }
  }
</script>